import { useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { Eye, EyeOff } from "lucide-react";

import "./ResetPasswordForm.css";

import service from "../../services/service";
import endpoints from "../../services/endpoints";

export default function ResetPasswordForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = location?.state?.token;

  /* STATES */
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [newPassword, setNewPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        newPassword,
        confirmPassword,
      };

      const res = await service.post(endpoints.auth.resetPassword, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const isSuccess = res?.status === 200 || res?.status === 201;

      if (!isSuccess) {
        return;
      }
      navigate("/login");
    } catch (error) {
      console.log("RESET PASSWORD ERROR", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-form-wrapper">
      {/* Heading */}
      <div className="login-heading">
        <h1>Reset Password</h1>

        <p>Enter your New & Confirm Password</p>
      </div>

      {/* Form */}
      <form className="login-form" onSubmit={handleReset}>
        {/* New Password */}
        <div className="form-group">
          <label>New Password</label>

          <div className="password-field">
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="••••••••"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />

            <button
              type="button"
              className="eye-btn"
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

       
        <div className="form-group">
          <label>Confirm Password</label>

          <div className="password-field">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            <button
              type="button"
              className="eye-btn"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* Submit */}
        <button type="submit" className="auth-login-btn" disabled={isLoading}>
          {isLoading ? "Saving..." : "Save"}
        </button>
      </form>
    </div>
  );
}
